import api from 'api'
import { PositionId, WorkerRequirementId } from './types'

type UpdateRequirementOnPositionParams = {
  positionId: PositionId
  requirementId: WorkerRequirementId
  mustHave: boolean
}

export async function updateRequirementOnPosition({
  positionId,
  requirementId,
  mustHave,
}: UpdateRequirementOnPositionParams): Promise<void> {
  await api.patch(
    `/admin/positions/${positionId}/requirements/${requirementId}`,
    { mustHave }
  )
}
